import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import * as constants from "../constants";

import Select, { components } from 'react-select';
import { deslugify, slugify } from "../helper/helperFunction";
import { useCountryPrefix } from "../routes/useCountryPrefix";
import FullScreenLoader from "./FullScreenLoader";
import { fetchAPI } from "../helper/fetchAPI";
import CustomImageComponent from "./CustomImageComponent";

const Search = (props) => {
  const { cusStyle, filters } = props;

  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();
  const countryPrefix = useCountryPrefix();

  const [showAll, setShowAll] = useState({
    showLocation: false,
    showSideLocation: false,
    showSideDeveloper: false,
    showSideYear: false,
  });

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.classList.toggle("custom-overlay");
  };
  const [isLoaded, setIsLoaded] = useState(true);

  let listingApiUrl = process.env.REACT_APP_API_URL;


  const [projectStatusIds, setProjectStatusIds] = useState([]);
  const [projectSalesIds, setProjectSalesIds] = useState([]);
  const [amenitiesIds, setAmenitiesIds] = useState([]);
  const [developersId, setDevelopersId] = useState([]);
  const [deliveryYear, setDeliveryYear] = useState([]);
  const [bedroomId, setBedroomId] = useState([]);
  const [bathroomId, setBathroomId] = useState([]);
  const [cityId, setCityId] = useState([]);

  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [minAreaSize, setMinAreaSize] = useState('');
  const [maxAreaSize, setMaxAreaSize] = useState('');
  const [projectTypeIds, setProjectTypeIds] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [propertyCount, setPropertyCount] = useState('');

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const Keyword = searchParams.get('q');
  const CityIds = searchParams.get('c');
  const ProjectStatuses = searchParams.get('p');
  const ProjectSales = searchParams.get('ps');
  const DeveloperIds = searchParams.get('dv');
  const DeliveryYears = searchParams.get('dy');
  const BedCounts = searchParams.get('bec');
  const BathCounts = searchParams.get('bac');
  const MinPrice = searchParams.get('mnp');
  const MaxPrice = searchParams.get('mxp');
  const MinAreaSize = searchParams.get('mns');
  const MaxAreaSize = searchParams.get('mxs');
  const Amenities = searchParams.get('a');
  const PropertyTypes = searchParams.get('pt');

  const ApplyFilters = searchParams.size > 0 ? true : false

  const isArabic = i18n.language === "ar";
  const language = isArabic ? "/ar" : "";
  let baseUrl = window.location.origin + "/" + countryPrefix + language + "/search"

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      const sidePanel = document.getElementById("mySidepanel");
      const toggleButton = document.querySelector(".altmenu");

      if (
        isOpen &&
        sidePanel &&
        !sidePanel.contains(event.target) &&
        toggleButton &&
        !toggleButton.contains(event.target)
      ) {
        setIsOpen(false);
        document.body.classList.remove("custom-overlay");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  React.useEffect(() => {

    setSearchText(Keyword ?? '')
    //setCityId(filters?.propertyCities?.find(city => slugify(city.itemName) === slugify(CityIds)))
    setCityId(CityIds ? CityIds.split(',') : [])
    setProjectStatusIds(ProjectStatuses !== null ? Object.keys(constants.ProjectStatus).filter(id => ProjectStatuses.includes(constants.ProjectStatus[id].label)).map(id => Number(id)) : [])
    setProjectSalesIds(ProjectSales !== null ? Object.keys(constants.PropertySaleTypes).filter(id => ProjectSales.includes(constants.PropertySaleTypes[id].label)).map(id => Number(id)) : [])
    setDevelopersId(DeveloperIds ? DeveloperIds.split(',') : [])
    setDeliveryYear(DeliveryYears ? DeliveryYears.split(',') : [])
    setBedroomId(BedCounts ? BedCounts.split(',') : [])
    setBathroomId(BathCounts ? BathCounts.split(',') : [])
    setMinPrice(MinPrice !== null ? MinPrice : '')
    setMaxPrice(MaxPrice !== null ? MaxPrice : '')
    setMinAreaSize(MinAreaSize !== null ? MinAreaSize : '')
    setMaxAreaSize(MaxAreaSize !== null ? MaxAreaSize : '')
    setAmenitiesIds(Amenities !== null ? Object.keys(constants.defaultAmenities).filter(id => Amenities.includes(constants.defaultAmenities[id].label)).map(id => Number(id)) : [])
    setProjectTypeIds(PropertyTypes !== null ? Object.keys(constants.defaultPropertyType).filter(id => PropertyTypes.includes(constants.defaultPropertyType[id].label)).map(id => Number(id)) : [])

    //getPropertyCount()
  }, [filters]);

  React.useEffect(() => {

    getPropertyCount()

  }, [developersId, projectStatusIds, projectSalesIds, amenitiesIds, developersId, deliveryYear, bedroomId, bathroomId, cityId, minPrice, maxPrice, minAreaSize, maxAreaSize, projectTypeIds, searchText]);

  const getPropertyCount = async () => {
    setIsLoaded(false)
    const language = isArabic ? "ar" : "en";

    const params = paramsPropertyCount()

    const queryString = params.length ? `${params.join('&')}` : '';

    listingApiUrl = `${listingApiUrl}${constants.propertyCount}?language=${language}&region_id=${countryPrefix}&${queryString}`

    const resListing = await fetchAPI(listingApiUrl, "Get");
    if (resListing?.status === 200) {
      setPropertyCount(resListing?.data?.propertyCount)

    }
    setIsLoaded(true)
  }

  const paramsPropertyCount = () => {
    const params = [];

    if (searchText) params.push(`Search=${searchText}`);
    if (cityId?.itemName) params.push(`Cities=${deslugify(cityId.itemName)}`);
    if (projectStatusIds?.length) { params.push(`ProjectStatuses=${projectStatusIds.map(id => Number(id))}`); }
    if (projectSalesIds?.length) params.push(`SaleType=${projectSalesIds.map(id => Number(id))}`);
    if (developersId.length > 0) params.push(`Developers=${developersId.map(dev => deslugify(dev)).join(',')}`);
    if (deliveryYear.length > 0) params.push(`DeliveryYears=${deliveryYear.map(dev => deslugify(dev)).join(',')}`);
    if (bedroomId.length > 0) params.push(`BedCounts=${bedroomId.map(dev => deslugify(dev)).join(',')}`);
    if (bathroomId.length > 0) params.push(`BathCounts=${bathroomId.map(dev => deslugify(dev)).join(',')}`);
    if (minPrice) params.push(`MinPrice=${minPrice}`);
    if (maxPrice) params.push(`MaxPrice=${maxPrice}`);
    if (minAreaSize) params.push(`MinAreaSize=${minAreaSize}`);
    if (maxAreaSize) params.push(`MaxAreaSize=${maxAreaSize}`);
    if (amenitiesIds?.length) params.push(`Amenities=${amenitiesIds.map(id => Number(id))}`);
    if (projectTypeIds?.length) params.push(`PropertyTypes=${projectTypeIds.map(id => Number(id))}`);


    if (params.length > 0) {
      params.push('ApplyFilters=true');
    }

    return params
  }

  const handleProjectStatusChange = (id) => {

    setProjectStatusIds((prev) =>
      prev.includes(id)
        ? prev.filter((ProjectStatusIds) => ProjectStatusIds !== id) // remove if already checked
        : [...prev, id] // add if not checked
    );

  };

  const handleProjectSalesChange = (id) => {
    setProjectSalesIds((prev) =>
      prev.includes(id)
        ? prev.filter((ProjectSalesIds) => ProjectSalesIds !== id) // remove if already checked
        : [...prev, id] // add if not checked
    );
  };

  const handleAmenitiesChange = (id) => {
    setAmenitiesIds((prev) =>
      prev.includes(id)
        ? prev.filter((amenitiesIds) => amenitiesIds !== id) // remove if already checked
        : [...prev, id] // add if not checked
    );
  };
  const handleProjectTypeChange = (id) => {
    setProjectTypeIds((prev) =>
      prev.includes(id)
        ? prev.filter((projectTypeIds) => projectTypeIds !== id) // remove if already checked
        : [...prev, id] // add if not checked
    );
  };

  // const handleDeveloperClick = (id) => {

  //   id = slugify(id)
  //   setDevelopersId((prev) => {
  //     if (prev.includes(id)) {

  //       return prev.filter((item) => item !== id); // If already selected → remove it

  //     } else {

  //       return [...prev, id]; // If not selected → add it

  //     }

  //   });
  // };
  // const handleDeliveryYearClick = (id) => {
  //   id = slugify(id)

  //   setDeliveryYear((prev) => {

  //     if (prev.includes(id)) {

  //       return prev.filter((item) => item !== id); // If already selected → remove it

  //     } else {

  //       return [...prev, id]; // If not selected → add it

  //     }
  //   });
  // };

  const handleBedroomClick = (id) => {
    id = slugify(id)

    setBedroomId((prev) => {
      if (prev.includes(id)) {

        return prev.filter((item) => item !== id); // If already selected → remove it

      } else {

        return [...prev, id]; // If not selected → add it

      }
    });
  };
  const handleBathroomClick = (id) => {
    id = slugify(id)

    setBathroomId((prev) => {
      if (prev.includes(id)) {

        return prev.filter((item) => item !== id); // If already selected → remove it

      } else {

        return [...prev, id]; // If not selected → add it

      }
    });
  };

  const resetClick = () => {
    setProjectStatusIds([]);
    setProjectSalesIds([]);
    setProjectTypeIds([]);
    setAmenitiesIds([]);
    setDevelopersId([]);
    setDeliveryYear([]);
    setBedroomId([]);
    setBathroomId([]);
    setCityId([]);
    setMinPrice('');
    setMaxPrice('');
    setMinAreaSize('');
    setMaxAreaSize('');

    window.location.href = baseUrl
  };

  const searchClicked = () => {
    const queryParams = params()
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
    const finalUrl = baseUrl + queryString.trim();

    window.location.href = finalUrl;
  }

  const params = () => {
    const params = [];
    if (searchText) params.push(`q=${searchText}`);
    if (cityId?.length) params.push(`c=${cityId.map(cit => slugify(cit))}`);
    if (projectStatusIds?.length) params.push(`p=${projectStatusIds.map(id => constants.ProjectStatus[id]?.label).filter(Boolean)}`);
    if (projectSalesIds?.length) params.push(`ps=${projectSalesIds.map(id => constants.PropertySaleTypes[id]?.label).filter(Boolean)}`);
    if (developersId.length > 0) params.push(`dv=${developersId.map(dev => slugify(dev)).join(',')}`);
    if (deliveryYear.length > 0) params.push(`dy=${deliveryYear.map(dev => slugify(dev)).join(',')}`);
    if (bedroomId.length > 0) params.push(`bec=${bedroomId.map(dev => slugify(dev)).join(',')}`);
    if (bathroomId.length > 0) params.push(`bac=${bathroomId.map(dev => slugify(dev)).join(',')}`);
    if (minPrice) params.push(`mnp=${minPrice}`);
    if (maxPrice) params.push(`mxp=${maxPrice}`);
    if (minAreaSize) params.push(`mns=${minAreaSize}`);
    if (maxAreaSize) params.push(`mxs=${maxAreaSize}`);
    if (amenitiesIds?.length) params.push(`a=${amenitiesIds.map(id => constants.defaultAmenities[id]?.label).filter(Boolean)}`);
    if (projectTypeIds?.length) params.push(`pt=${projectTypeIds.map(id => constants.defaultPropertyType[id]?.label).filter(Boolean)}`);
    return params
  }

  const MultiValueContainer = (props) => {

    const { selectProps, data, stateName } = props;

    const allSelected = selectProps.value || [];
    const index = allSelected.findIndex(
      (item) => item.itemName === data.itemName
    );

    // Expanded mode → show default design for all
    if (showAll?.[stateName]) {
      return <components.MultiValueContainer {...props} />;
    }

    // Collapsed mode
    if (index === 0) {
      if (allSelected.length > 1) {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <components.MultiValueContainer {...props} />
            <span
              style={{ marginLeft: 5, color: "#007b9a", cursor: "pointer" }}
              onClick={() =>
                // setShowAll(true)
                setShowAll(prev => ({
                  ...prev,
                  [stateName]: true
                }))
              }
            >
              +{allSelected.length - 1} more
            </span>
          </div>
        );
      }
      return <components.MultiValueContainer {...props} />;
    }

    return null; // hide others in collapsed mode
  };

  return (
    <>
      <section
        className={`filter-section ${cusStyle}`}
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div className="container">
          <div className="filter-wrapper">
            <div className="row align-items-center">
              <div className="col-md-12 col-lg-7 p-0">
                <div className="row">
                  <div className="col-md-7">
                    <div className="border-block">
                      <label>{t("keyword")}</label>
                      <input
                        id="search"
                        type="search"
                        className="form-control"
                        placeholder={t("search_keyword")}
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value)
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // optional but recommended
                            searchClicked();    // this triggers your search function
                          }
                        }}
                      ></input>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="border-block">
                      <label>{t("location")}</label>
                      <div className="input-group location-select-filter">
                        <Select
                          className="form-control"
                          value={filters?.propertyCities.filter((item) =>
                            cityId.includes(slugify(item.itemName))
                          )}
                          onChange={(selectedOptions) => {
                            // selectedOptions = array of objects
                            const ids = selectedOptions.map((opt) => slugify(opt.itemName));
                            setCityId(ids);
                            if (selectedOptions?.length <= 1) setShowAll(prev => ({
                              ...prev,
                              showLocation: false
                            }));

                          }}
                          onMenuClose={() => setShowAll(prev => ({
                            ...prev,
                            showLocation: false
                          }))}
                          placeholder={t("location")}
                          options={filters?.propertyCities}
                          getOptionLabel={(e) => e.itemName}
                          getOptionValue={(e) => e.itemName}
                          isMulti
                          closeMenuOnSelect={false}
                          // components={{ MultiValueContainer }}
                          components={{
                            MultiValueContainer: (props) => (
                              <MultiValueContainer {...props} stateName="showLocation" />
                            ),
                          }}
                        />
                        <button
                          className="search-btn"
                          type="button"
                          id="button-addon2"
                        >
                          <CustomImageComponent src={"/assets/img/location-icon.svg"} alt={"Location"}></CustomImageComponent>
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="col-md-12 col-lg-5 p-0 text-end btn-block">
                <div className={`advance-search ${ApplyFilters ? "active" : ""}`}>
                  <span className="clear-icon" onClick={resetClick}>
                    <i className="fas fa-times"></i>
                  </span>
                  <button className="theme-btn" onClick={toggleMenu}> {t("advance_search")}
                    <CustomImageComponent src={"/assets/img/filter-icon.svg"} alt={"filter-icon"} />
                  </button>
                </div>

                <a onClick={searchClicked} className="theme-btn theme-btn-secondary">
                  {t("search")} <i className="fa-solid fa-magnifying-glass"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section >

      <div id="mySidepanel" className={`sidepanel ${isOpen ? "open" : ""}`}>
        <div className="closebtn altmenu" onClick={toggleMenu}><i className="fa-solid fa-xmark"></i></div>

        <div className="title-blk">
          <h3> <i className="fa-solid fa-sliders"></i> {t("advance_search")}</h3>

        </div>
        <div className="card">
          <h4 className="title">{t("project_statuses")}</h4>
          <div className="checklist">

            {Object.entries(constants.ProjectStatus).map(([key, item]) => (

              <label className="contain" key={key}>{t(item.label)}
                <input id={`chkprojectType${key}`} type="checkbox" checked={projectStatusIds.includes(Number(key))}
                  onChange={() => handleProjectStatusChange(Number(key))} />
                <span className="checkmark"></span>
              </label>

            ))}

          </div>
        </div>

        <div className="card">
          <h4 className="title">{t("location")}</h4>
          <div >
            <Select
              value={filters?.propertyCities.filter((item) =>
                cityId.includes(slugify(item.itemName))
              )}
              onChange={(selectedOptions) => {
                // selectedOptions = array of objects
                const ids = selectedOptions.map((opt) => slugify(opt.itemName));
                setCityId(ids);
                if (selectedOptions?.length <= 1) setShowAll(prev => ({
                  ...prev,
                  showSideLocation: false
                }));

              }}
              onMenuClose={() => setShowAll(prev => ({
                ...prev,
                showSideLocation: false
              }))}
              placeholder={t("location")}
              options={filters?.propertyCities}
              getOptionLabel={(e) => e.itemName}
              getOptionValue={(e) => e.itemName}
              isMulti
              closeMenuOnSelect={false}
              isClearable={false}
              components={{
                MultiValueContainer: (props) => (
                  <MultiValueContainer {...props} stateName="showSideLocation" />
                ),
              }}
            />

          </div>
        </div>


        <div className="card">
          <h4 className="title">{t("developers")}</h4>
          <Select
            value={filters?.propertyDevelopers.filter((item) =>
              developersId.includes(slugify(item.itemName))
            )}
            onChange={(selectedOptions) => {
              // selectedOptions = array of objects
              const ids = selectedOptions.map((opt) => slugify(opt.itemName));
              setDevelopersId(ids);
              if (selectedOptions?.length <= 1) setShowAll(prev => ({
                ...prev,
                showSideDeveloper: false
              }));
            }}
            onMenuClose={() => setShowAll(prev => ({
              ...prev,
              showSideDeveloper: false
            }))}
            placeholder={t("developers")}
            options={filters?.propertyDevelopers}
            getOptionLabel={(e) => e.itemName}
            getOptionValue={(e) => e.itemName}
            isClearable={false}
            isMulti
            closeMenuOnSelect={false}
            components={{
              MultiValueContainer: (props) => (
                <MultiValueContainer {...props} stateName="showSideDeveloper" />
              ),
            }}
          />

        </div>
        <div className="card">
          <h4 className="title">{t("delivery_years")}</h4>

          <Select
            value={filters?.propertyDeliveryYears.filter((item) =>
              deliveryYear.includes(slugify(item.itemName))
            )}
            onChange={(selectedOptions) => {
              // selectedOptions = array of objects
              const ids = selectedOptions.map((opt) => slugify(opt.itemName));
              setDeliveryYear(ids);
              if (selectedOptions?.length <= 1) setShowAll(prev => ({
                ...prev,
                showSideYear: false
              }));
            }}
            onMenuClose={() => setShowAll(prev => ({
              ...prev,
              showSideYear: false
            }))}
            placeholder={t("delivery_years")}
            options={filters?.propertyDeliveryYears}
            getOptionLabel={(e) => e.itemName}
            getOptionValue={(e) => e.itemName}
            isMulti
            closeMenuOnSelect={false}
            components={{
              MultiValueContainer: (props) => (
                <MultiValueContainer {...props} stateName="showSideYear" />
              ),
            }}
          />

          {/* <ul className="num-list tags-list">
            {filters?.propertyDeliveryYears?.length > 0 &&
              (filters.propertyDeliveryYears.map((item, index) => (
                <li key={index}>
                  <a className={deliveryYear.includes(slugify(item)) ? "bg-primary" : ""} onClick={() => handleDeliveryYearClick(item)}>{item}</a>
                </li>
              )))}
          </ul> */}
        </div>
        <div className="card">
          <h4 className="title">{t("sale_types")}</h4>
          <ul className="num-list tags-list">
            {Object.entries(constants.PropertySaleTypes).map(([key, item]) => (

              <label className="contain" key={key}>{t(item.label)}
                <input id={`chkprojectSalesType${key}`} type="checkbox" checked={projectSalesIds.includes(Number(key))}
                  onChange={() => handleProjectSalesChange(Number(key))} />
                <span className="checkmark"></span>
              </label>

            ))}
          </ul>
        </div>
        <div className="card">
          <h4 className="title">{t("bedrooms")}</h4>
          <ul className="num-list">
            <li>
              <a className={bedroomId.includes(slugify("1")) ? "bg-primary" : ""} onClick={() => handleBedroomClick("1")}>1</a>
            </li>
            <li>
              <a className={bedroomId.includes(slugify("2")) ? "bg-primary" : ""} onClick={() => handleBedroomClick("2")}>2</a>
            </li>
            <li>
              <a className={bedroomId.includes(slugify("3")) ? "bg-primary" : ""} onClick={() => handleBedroomClick("3")}>3</a>
            </li>
            <li>
              <a className={bedroomId.includes(slugify("4")) ? "bg-primary" : ""} onClick={() => handleBedroomClick("4")}>4</a>
            </li>
            <li>
              <a className={bedroomId.includes(slugify("5")) ? "bg-primary" : ""} onClick={() => handleBedroomClick("5")}>5+</a>
            </li>
          </ul>
        </div>
        <div className="card">
          <h4 className="title">{t("bathrooms")}</h4>
          <ul className="num-list">
            <li>
              <a className={bathroomId.includes(slugify("1")) ? "bg-primary" : ""} onClick={() => handleBathroomClick("1")}>1</a>
            </li>
            <li>
              <a className={bathroomId.includes(slugify("2")) ? "bg-primary" : ""} onClick={() => handleBathroomClick("2")}>2</a>
            </li>
            <li>
              <a className={bathroomId.includes(slugify("3")) ? "bg-primary" : ""} onClick={() => handleBathroomClick("3")}>3</a>
            </li>
            <li>
              <a className={bathroomId.includes(slugify("4")) ? "bg-primary" : ""} onClick={() => handleBathroomClick("4")}>4</a>
            </li>
            <li>
              <a className={bathroomId.includes(slugify("5")) ? "bg-primary" : ""} onClick={() => handleBathroomClick("5")}>5+</a>
            </li>
          </ul>
        </div>
        <div className="card">
          <h4 className="title">{t("payments")}</h4>

          <div className="">
            <div className="d-flex justify-content-between">
              <div className="input-block-wrapper">
                <h5 className="sub-title">{t("minimum_payment")}</h5>
                <div className="input-block">
                  <input className="form-control"
                    id="minAmount"
                    type="text"
                    placeholder={t("min_amount")}
                    value={minPrice}
                    onChange={(e) => {
                      setMinPrice(e.target.value.replace(/[^0-9]/g, ""))
                    }} />
                  <span>{t("egp")}</span>
                </div>
              </div>
              <div className="input-block-wrapper">
                <h5 className="sub-title">{t("maximum_payment")}</h5>
                <div className="input-block">
                  <input className="form-control"
                    id="maxAmount"
                    type="text"
                    placeholder={t("max_amount")}
                    value={maxPrice}
                    onChange={(e) => {
                      setMaxPrice(e.target.value.replace(/[^0-9]/g, ""))
                    }} />
                  <span>{t("egp")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <h4 className="title">{t("property_area")} ({t("Metersq")})</h4>

          <div className="">
            <div className="d-flex justify-content-between">
              <div className="input-block-wrapper">
                <h5 className="sub-title">{t("minimum_area")}</h5>
                <div className="input-block">
                  <input className="form-control"
                    id="minArea"
                    type="text"
                    placeholder={t("min_area")}
                    value={minAreaSize}
                    onChange={(e) => {
                      setMinAreaSize(e.target.value.replace(/[^0-9]/g, ""))
                    }} />
                </div>
              </div>
              <div className="input-block-wrapper">
                <h5 className="sub-title">{t("maximum_area")}</h5>
                <div className="input-block">
                  <input className="form-control"
                    id="maxArea"
                    type="text"
                    placeholder={t("max_area")}
                    value={maxAreaSize}
                    onChange={(e) => {
                      setMaxAreaSize(e.target.value.replace(/[^0-9]/g, ""))
                    }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <h4 className="title">{t("amenities")}</h4>
          <ul className="num-list tags-list">
            {Object.entries(constants.defaultAmenities).map(([key, item]) => (
              <li key={key}>
                <label className="contain" key={key}>{t(item.label)}
                  <input id={`chkAmenities${key}`} type="checkbox" checked={amenitiesIds.includes(Number(key))}
                    onChange={() => handleAmenitiesChange(Number(key))} />
                  <span className="checkmark"></span>
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div className="card">
          <h4 className="title">{t("property_types")}</h4>
          <ul className="num-list tags-list">
            {Object.entries(constants.defaultPropertyType).map(([key, item]) => (
              <li key={key}>
                <label className="contain" key={key}>{t(item.label)}
                  <input id={`chkPropertyType${key}`} type="checkbox" checked={projectTypeIds.includes(Number(key))}
                    onChange={() => handleProjectTypeChange(Number(key))} />
                  <span className="checkmark"></span>
                </label>
              </li>
            ))}
          </ul>
        </div>


        <div className="btn-block">

          {/* <a onClick={searchClicked} className="theme-btn theme-btn-secondary">{t("search")} ({propertyCount}) </a> */}
          <a onClick={searchClicked} className="theme-btn theme-btn-secondary">
            {!isLoaded ? (

              <>{t("search")}  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span></>
            ) : (
              <>{t("search")} ({propertyCount})</>
            )}
          </a>
          <a onClick={resetClick} className="theme-btn">{t("reset_all")}</a>
        </div>

      </div >
    </>

  );
};

export default Search;
